import $ from 'jquery'
import 'jquery.cookie'

import store from 'base/store'
import cookies from 'cookies.yml'

// Ensure console is available
const console = window.console || { log: () => undefined }

// Proxying additional console methods so that they dont break older browsers
// if they're undefined
for (const additionalMethod of ['debug', 'info', 'warn', 'error', 'trace']) {
  if (!console[additionalMethod]) {
    console[additionalMethod] = console.log
  }
}

const utils = {}

// Only log/warn when debugging
for (const func of ['log', 'warn']) {
  if (!store.getState().appConfig.isProduction || $.cookie(cookies.DEBUG)) {
    // Create a function that directly passes its arguments to the given
    // logging property of console
    utils[func] = eval(`(function () {
        var messages = Array.prototype.slice.call(arguments, 0);
        return console.${func}.apply(console, messages);
      })`)
  } else {
    // No-op that matches the return semantics of `console` logging functions
    utils[func] = () => undefined
  }
}

// Errors will always be reported regardless of environment
const error = (...messages) => console.error(...messages)

const log = utils.log
const warn = utils.warn

export { log, warn, error }
